import React from 'react';

import Typography from '@mui/material/Typography';

export interface RequiredIconProps {}

const RequiredIcon: React.FC<RequiredIconProps> = () => (
    <Typography component="span" color="error">
        *
    </Typography>
);

export default RequiredIcon;
